export const API_ERROR_CODES = {
  0: "ok",
  118: "api_error.unknown_brand",
  124: "api_error.brand_service_not_allowed",
  127: "api_error.invalid_app",
  129: "api_error.allowed_brands_error",
  205: "api_error.body_required_field_missing",
  299: "api_error.internal_error",
  1119: "api_error.sending_not_valid",
  1206: "api_error.user_already_exists",
  1215: "api_error.user_not_allowed",
  1216: "api_error.user_not_found",
  1221: "api_error.user_operation_self",
  1248: "api_error.dfa_option",
  1261: "api_error.login_email_required",
  1263: "api_error.email_already_exists",
  1265: "api_error.nif_field",
  1270: "api_error.update_double_factor",
  1271: "api_error.block_user",
  1272: "api_error.delete_user",
  1273: "api_error.user_close_session",
  1276: "api_error.credential_check_error",
  1277: "api_error.invalid_credential_format",
  1282: "api_error.database_credential_not_found",
  1283: "api_error.invalid_email_format",
  1284: "api_error.invalid_phone_format",
  1286: "api_error.block_unblock_operation",
  1287: "api_error.required_login_email",
  1290: "api_error.user_already_unblocked",
  1292: "api_error.user_already_blocked",
  1296: "api_error.invalid_credential_type",
  1306: "api_error.zure_delete_user",
  1307: "api_error.zure_create_user",
  1900: "api_error.otp_validation_error",
  1901: "api_error.unknown_operation_type",
  1903: "api_error.pin_tries_exceeded",
  1905: "api_error.invalid_receiver_format",
  1910: "api_error.pin_uses_exceeded",
  1911: "api_error.unknown_pin_operation",
  1912: "api_error.wrong_otp_pin",
  1913: "api_error.pin_expired",
  1917: "api_error.otp_required_fields_missing",
  2100: "api_error.invalid_date_value",
  2505: "api_error.user_no_permission",
  2803: "api_error.decoding_error",
  2804: "api_error.encryption_error",
  12000: "api_error.invalid_process_type",
  12001: "api_error.coding_timeout_exceeded",
  12002: "api_error.invalid_encrypted_chain",
  12003: "api_error.parameters_not_found",
  12004: "api_error.invalid_process_type_brand_language",
  12006: "api_error.user_without_credential_login",
  30004: "api_error.rest",
  30910: "api_error.token_not_found",
  30912: "api_error.reliable_session_required",
  31400: "api_error.deactivated_double_factor",
  31600: "api_error.sms_communication_error",
  31601: "api_error.email_communication_error",
};

export const HTTP_ERROR_CODES = {
  400: "http_error.400",
  401: "http_error.401",
  403: "http_error.403",
  404: "http_error.404",
  500: "http_error.500",
};
